import { createFileRoute } from "@tanstack/react-router"

import { issueTypeFieldsViewStaticData } from "../../../../../../../../views/IssueTypeSettingsFieldsView/constants"
import { IssueTypeSettingsFieldsView } from "../../../../../../../../views/IssueTypeSettingsFieldsView/IssueTypeSettingsFieldsView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/fields",
)({
	component: IssueTypeSettingsFieldsView,
	staticData: issueTypeFieldsViewStaticData,
})
